import { BasicModal } from '@components';
import {
  clearLtlQuoteResults,
  setCurrentLTLQuoteView,
} from '@store/ltl/actions';
import { closeModal, isModalOpen } from '@store/modals';
import { LtlQuoteShell } from '@views/ltl/useLtlComponents';
import { onCleanup } from 'solid-js';

type PropsT = {
  id?: string;
  loadId?: number;
  quoteParametersId?: number;
  quoteId?: number;
};

/**
 * LTL Quoting Modal
 */
export const LtlQuotingModal = (props: PropsT) => {
  let suffix = '';
  if (props.id !== undefined) {
    suffix = `-${props.id}`;
  }

  const modalId = `ltl-quoting-modal${suffix}`;

  const closeQuotingModal = () => {
    closeModal(modalId);
    clearLtlQuoteResults();
    setCurrentLTLQuoteView('quote-form');
  };

  // The modal's open state lives in the global modal store, so it survives
  // navigating away (e.g. order details -> loadboard) while the modal is open.
  // Close it on unmount so the next mount of this modal id starts closed.
  onCleanup(() => {
    if (isModalOpen(modalId)) {
      closeQuotingModal();
    }
  });

  return (
    <BasicModal
      id={modalId}
      width={'80vw'}
      height={'280vh'}
      showClose={true}
      footer={false}
      header={false}
      mainContainerStyles={{ padding: '0px', overflow: 'hidden' }}
      onClose={closeQuotingModal}
    >
      <LtlQuoteShell
        isModal={true}
        loadId={props.loadId}
        quoteParametersId={props.quoteParametersId}
        quoteId={props.quoteId}
      />
    </BasicModal>
  );
};
